/* eslint-disable no-undef */
import React, { useEffect, useState } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate, useLocation } from "react-router-dom";
import * as settingActions from "../actions/settingActions";
import { getSubdomainPath } from "../utils/helpers";
import ScrollToTop from "./layout/ScrollToTop";
import Loading from "../Component/Loader";
import PopupModalWithOk from "../utils/helpers/popupModalOk";
import Page from "../Pages";
import "bootstrap/dist/css/bootstrap.min.css";
import "./../assets/css/app.css";
import "./../assets/css/media.css";
import PropTypes from "prop-types";

const App = (props) => {
  const { isFetching, isAuth, setting, userInfo } = props;
  const history = useNavigate();
  const dispatch = useDispatch();
  const redirectTo = useSelector((state) => state.redirectTo);
  const location = useLocation();

  const [showEligibilityPopup, setShowEligibilityPopup] = useState(false);

  useEffect(() => {
    if (isAuth && userInfo && userInfo.role_id == 'Mentor' && userInfo.is_eligible_mentor === false) {
      const shown = localStorage.getItem("mentorEligibilityPopupShown");
      const subDomainPath1 = getSubdomainPath();
      if (!shown && ['siddev', 'siduat', 'sid'].includes(subDomainPath1)) {
        setShowEligibilityPopup(true);
      }
    } else {
      setShowEligibilityPopup(false);
    }
  }, [isAuth, userInfo]);

  const handleCloseEligibilityPopup = () => {
    setShowEligibilityPopup(false);
    localStorage.setItem("mentorEligibilityPopupShown", "true");
  };

  useEffect(() => {
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.href = globalThis.location.origin + location.pathname;
    }
    if (globalThis?.location?.hostname?.includes('essec')) {
      const elements = document.querySelectorAll('.logo');
      for (const el of elements) {
        el.classList.remove('logo');
      }
    }
  }, [location]);

  // Apply domain-specific font family to body
  useEffect(() => {
    const subDomainPath = getSubdomainPath();
    const bodyElement = document.body;

    bodyElement.classList.toggle('sid_domain', subDomainPath === 'siddev' || subDomainPath === 'siduat' || subDomainPath === 'sid');
  }, []);

  useEffect(() => {
    if (redirectTo.redirectTo) {
      dispatch({
        type: "REDIRECT",
        payload: false,
      });
      history(redirectTo.redirectTo);
    }
  });

  useEffect(() => {
    if (!setting?.favicon_path) return;

    let link = document.querySelector("link[rel='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.type = "image/png";
    link.href = `${setting.favicon_path}?v=${Date.now()}`;
  }, [setting?.favicon_path]);

  const moduleRenderData = props?.setting?.module_data
  const isSectionShow = (name) => {
    if (moduleRenderData === 'undefined') {
      return true
    }
    return moduleRenderData?.some((item) => (item?.name == name && item?.status == "Enabled" && item?.is_default == "Yes"))
  }

  useEffect(() => {
    if (!moduleRenderData) return;

    let moduleName = '/'
    if (location.pathname.includes('/mentors') || location.pathname.includes('/certificate') || location.pathname.includes('/schedule-meeting-calendar') || location.pathname.includes('/current-mentees') || location.pathname.includes('/mentees-request') || location.pathname.includes('/mentees-logs') || location.pathname.includes('/suggested-mentors') || location.pathname.includes('/my-mentors') || location.pathname.includes('/pending-mentors') || location.pathname.includes('/my-diagnostic-toolkit')) {
      moduleName = 'Mentoring Engagement'
    }
    // else if (location.pathname.includes('/community-details') || location.pathname.includes('/refer')) {
    //   moduleName = 'Communities'
    // }
    else if (location.pathname.includes('/refer')) {
      moduleName = 'Mentoring Engagement';
    }
    else if (location.pathname.includes('/community-details')) {
      moduleName = 'Communities';
    }

    else if (location.pathname.includes('/resource-hub')) {
      moduleName = 'Resource Hub'
    } else if (location.pathname.includes('/partnerships')) {
      moduleName = 'Home Page Content'
    } else if (location.pathname.includes('/event')) {
      moduleName = 'Events'
    }
    else if (location.pathname.includes('/forum')) {
      moduleName = 'Forum'
    } else if (location.pathname.includes('/manage-profile') || location.pathname.includes('/delete-my-profile')) {
      moduleName = 'My Profile'
    } else if (location.pathname.includes('/about-us') || location.pathname.includes('/page') || location.pathname.includes('/faq')) {
      moduleName = 'Site Content'
    } else if (location.pathname.includes('/change-password')) {
      moduleName = 'Change Password'
    }
    if (moduleName != '/' && !isSectionShow(moduleName)) {
      history('/');
    }
    document.documentElement.style.setProperty('--themeBlue', props?.setting?.text_color_1 || '#0078FF');
    document.documentElement.style.setProperty('--themeRed', props?.setting?.text_color_2 || '#ef4343');
    document.documentElement.style.setProperty('--themeBlueHover', props?.setting?.text_color_3 || '#0078FF');
  }, [props?.setting?.text_color_1, props?.setting?.text_color_2, props?.setting?.text_color_3]);

  // Apply domain-specific theme colors from setting API keys:
  // website_textcolor  → --themeTextColor
  // website_backgroundcolor → --themeBackgroundColor
  // website_hovercolor → --themeHoverColor
  useEffect(() => {
    const subdomain = getSubdomainPath();
    if (!subdomain) return;

    const root = document.documentElement;

    if (props?.setting?.website_textcolor) {
      root.style.setProperty('--themeTextColor', props.setting.website_textcolor);
    }

    if (props?.setting?.website_backgroundcolor) {
      root.style.setProperty('--themeBackgroundColor', props.setting.website_backgroundcolor);
    }

    if (props?.setting?.website_hovercolor) {
      root.style.setProperty('--themeHoverColor', props.setting.website_hovercolor);
    }

    if (props?.setting?.website_theme_active_color) {
      root.style.setProperty('--themeActiveColor', props.setting.website_theme_active_color);
    }

    if (props?.setting?.website_theme_sidebar_background_color) {
      root.style.setProperty('--themeSidebarBackgroundColor', props.setting.website_theme_sidebar_background_color);
    }

    if (props?.setting?.website_theme_sidebar_text_color) {
      root.style.setProperty('--themeSidebarTextColor', props.setting.website_theme_sidebar_text_color);
    }

    if (props?.setting?.website_theme_sidebar_hover_color) {
      root.style.setProperty('--themeSidebarHoverColor', props.setting.website_theme_sidebar_hover_color);
    }

    if (props?.setting?.website_theme_button_text_color) {
      root.style.setProperty('--themeBtnTextColor', props.setting.website_theme_button_text_color);
    }
    if (props?.setting?.unavailable_txt_clr) {
      root.style.setProperty('--unavailableTxtClr', props.setting.unavailable_txt_clr);
    }
    if (props?.setting?.unavailable_bg_clr) {
      root.style.setProperty('--unavailableBgClr', props.setting.unavailable_bg_clr);
    }
    if (props?.setting?.available_txt_clr) {
      root.style.setProperty('--availableTxtClr', props.setting.available_txt_clr);
    }
    if (props?.setting?.available_bg_clr) {
      root.style.setProperty('--availableBgClr', props.setting.available_bg_clr);
    }
  }, [
    props?.setting?.website_textcolor,
    props?.setting?.website_backgroundcolor,
    props?.setting?.website_hovercolor,
    props?.setting?.website_theme_active_color,
    props?.setting?.website_theme_sidebar_background_color,
    props?.setting?.website_theme_sidebar_text_color,
    props?.setting?.website_theme_sidebar_hover_color,
    props?.setting?.website_theme_button_text_color,
    props?.setting?.unavailable_txt_clr,
    props?.setting?.unavailable_bg_clr,
    props?.setting?.available_txt_clr,
    props?.setting?.available_bg_clr,
  ]);

  return (
    <>
      {isFetching && !location?.pathname?.includes('manage-profile') && location?.pathname !== '/suggested-mentors' && <Loading />}
      <ScrollToTop />
      <Page isAuth={isAuth} />
      <PopupModalWithOk
        show={showEligibilityPopup}
        onHide={handleCloseEligibilityPopup}
        title="Mentor Eligibility Advisory"
        message={
          <>
            Thank you for your interest in being a mentor.
            <br />
            <br />
            Mentor registration is currently only open to SID Senior Accredited Directors, Fellows and Lifetime Members.
            <br />
            <br />
            If you have any queries, please write to{" "}
            <a href="mailto:mentoring@sid.org.sg" style={{ color: "var(--themeBlueHover)" }}>
              mentoring@sid.org.sg
            </a>.
          </>
        }
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

App.propTypes = {
  isFetching: PropTypes.bool,
  isAuth: PropTypes.bool,
  userInfo: PropTypes.object,
  setting: PropTypes.shape({
    module_data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        status: PropTypes.string,
        is_default: PropTypes.string,
      })
    ),
    text_color_1: PropTypes.string,
    text_color_2: PropTypes.string,
    text_color_3: PropTypes.string,
    favicon_path: PropTypes.string,
    website_textcolor: PropTypes.string,
    website_backgroundcolor: PropTypes.string,
    website_hovercolor: PropTypes.string,
  }),
};

function mapStateToProps(state) {
  return {
    isFetching: state.isFetching,
    isAuth: state.isAuth,
    setting: state.setting,
    userInfo: state.userInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...settingActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
